export default function TruckIcon() {
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6666 3.66634H14.1666V0.333008H2.49992C1.58325 0.333008 0.833252 1.08301 0.833252 1.99967V11.1663H2.49992C2.49992 12.5497 3.61659 13.6663 4.99992 13.6663C6.38325 13.6663 7.49992 12.5497 7.49992 11.1663H12.4999C12.4999 12.5497 13.6166 13.6663 14.9999 13.6663C16.3833 13.6663 17.4999 12.5497 17.4999 11.1663H19.1666V6.99967L16.6666 3.66634ZM4.99992 12.4163C4.30825 12.4163 3.74992 11.858 3.74992 11.1663C3.74992 10.4747 4.30825 9.91634 4.99992 9.91634C5.69159 9.91634 6.24992 10.4747 6.24992 11.1663C6.24992 11.858 5.69159 12.4163 4.99992 12.4163ZM16.2499 4.91634L17.8833 6.99967H14.1666V4.91634H16.2499ZM14.9999 12.4163C14.3083 12.4163 13.7499 11.858 13.7499 11.1663C13.7499 10.4747 14.3083 9.91634 14.9999 9.91634C15.6916 9.91634 16.2499 10.4747 16.2499 11.1663C16.2499 11.858 15.6916 12.4163 14.9999 12.4163Z"
        fill="#323232"
      />
    </svg>
  );
}
